import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=71708564&scoped=true&"
import script from "./InvoiceHistory.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=71708564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71708564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTooltip})
